import styled from "styled-components";
import { CssRule } from "../../../../themes/architecture/css-helpers/css-rule";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { hexToRgba } from "../../../../themes/hex-to-rgba";

const BalanceButtonsGroupDefaultBox = styled.div`
    /* .balance-box-buttons-group */
    display: flex;
    justify-content: space-between;
    width: 100%;
    ${CssRule.For.mobile.build()} &{
        margin: 1.5rem 0 0.5rem 0;
        padding: 1.5rem;
        background: #232323;
        border-radius: 5px;
    }
`;

/* 777 */
const BalanceButtonsGroupCasino777Box = styled(BalanceButtonsGroupDefaultBox)`
    ${CssRule.For.mobile.build()} &{
        margin: 1.5rem 0;
        background: linear-gradient(-45deg, ${({theme}) => hexToRgba(theme.colors.brandPrimary, 0.8)} 33.33%, ${({theme}) => hexToRgba(theme.colors.userMenuTitleText, 0.1)} 33.33%, ${({theme}) => hexToRgba(theme.colors.userMenuTitleText, 0.2)} 50%, ${({theme}) => hexToRgba(theme.colors.brandPrimary, 0.8)} 50%, ${({theme}) => hexToRgba(theme.colors.brandPrimary, 0.8)} 83.33%, ${({theme}) => hexToRgba(theme.colors.userMenuTitleText, 0.1)} 83.33%, ${({theme}) => hexToRgba(theme.colors.userMenuTitleText, 0.1)} 100%);
        background-size: 4px 4px;
    }
`;

/* harrahs */
/* wsop */
const BalanceButtonsGroupHarrahsWsopBox = styled(BalanceButtonsGroupDefaultBox)`
    ${CssRule.For.mobile.build()} &{
        margin: 0;
        background: transparent;
    }
`;

export const BalanceButtonsGroupBox = styledByTheme(BalanceButtonsGroupDefaultBox)
    .forCasino777(BalanceButtonsGroupCasino777Box)
    .forHarrahs(BalanceButtonsGroupHarrahsWsopBox)
    .forWsop(BalanceButtonsGroupHarrahsWsopBox)
    .apply();
